import React from 'react'
import T from 'prop-types'
import cx from 'classnames'
import moment from 'moment'

class Calendar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      focusedDate: +this.props.selectedDate
    }
  }


  static displayName = 'Calendar'

  static propTypes = {
    onDateSelect: T.func,
    selectedDate: T.instanceOf(Date),
    utc: T.bool,
    validRange: T.array // [startTime|null, endTime|null] range of valid selections
  }

  static defaultProps = {
    selectedDate: new Date(),
    utc: false,
    validRange: [null, null]
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectedDate !== this.props.selectedDate) {
      this.setState({ focusedDate: +nextProps.selectedDate })
    }
  }

  _moment = value => {
    return this.props.utc ? moment.utc(value) : moment(value)
  }

  _onPrevMonthClick = e => {
    e.preventDefault()
    const prevMonthMoment = this._moment(this.state.focusedDate).subtract(
      1,
      'month'
    )
    this.setState({ focusedDate: +prevMonthMoment })
  }

  _onNextMonthClick = e => {
    e.preventDefault()
    const nextMonthMoment = this._moment(this.state.focusedDate).add(1, 'month')
    this.setState({ focusedDate: +nextMonthMoment })
  }

  _onTbodyClick = e => {
    e.preventDefault()
    var node = e.target
    var onDateSelect = this.props.onDateSelect
    while (node) {
      const timestamp =
        node.getAttribute && node.getAttribute('data-calendar-date')
      if (timestamp) {
        if (onDateSelect) {
          onDateSelect(new Date(+timestamp))
        }
        break
      }
      node = node.parentNode
    }
  }

  _isValidSelection = timestamp => {
    const { validRange } = this.props
    if (!validRange || validRange.length !== 2) {
      return true
    }
    return (
      (validRange[0] == null || timestamp >= validRange[0]) &&
      (validRange[1] == null || timestamp <= validRange[1])
    )
  }

  renderWeeks = () => {
    // We'll always render six weeks to prevent height changes when stepping through months.
    // TODO try to distribute the spare weeks more equally before and after, e.g. Feb 2015
    var day = this._moment(this.state.focusedDate)
      .startOf('month')
      .startOf('week')
    var rows = []
    for (let weekNum = 1; weekNum <= 6; weekNum++) {
      const cells = []
      for (let dayNum = 1; dayNum <= 7; dayNum++) {
        const isSelectable = this._isValidSelection(+day)
        const classes = cx({
          selected: day.isSame(this.props.selectedDate, 'day'),
          outside_month: !day.isSame(this.state.focusedDate, 'month'),
          invalid_selection: !isSelectable
        })
        cells.push(
          <td className={classes} key={'week' + weekNum + '.day' + dayNum}>
            <a data-calendar-date={isSelectable ? +day : null} href="#">
              {day.format('D')}
            </a>
          </td>
        )
        day.add(1, 'days')
      }
      rows.push(
        <tr key={'week' + weekNum}>
          {cells}
        </tr>
      )
    }
    return rows
  }

  render() {
    var focusedMoment = this._moment(this.state.focusedDate).startOf('day')
    return (
      <div className="calendar">
        <div className="calendar_header">
          <a
            className="calendar_month_nav calendar_month_prev icon icon-triangle-l"
            href="#"
            onClick={this._onPrevMonthClick}
          />
          <span className="calendar_month_name">
            {focusedMoment.format('MMMM YYYY')}
          </span>
          <a
            className="calendar_month_nav calendar_month_next icon icon-triangle-r"
            href="#"
            onClick={this._onNextMonthClick}
          />
        </div>
        <table>
          <thead>
            <tr>
              {moment.weekdaysShort().map(day =>
                <th key={day}>
                  {day}
                </th>
              )}
            </tr>
          </thead>
          <tbody onClick={this._onTbodyClick}>
            {this.renderWeeks()}
          </tbody>
        </table>
      </div>
    )
  }
}

export default Calendar
